module.exports = __webpack_public_path__ + "static/media/wheel-glow.4da64cfb.png";